import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import FormInput from '../forms/FormInput';
import GenericModal from './GenericModal';
import CurrencyProp from '../../sections/profile/propTypes/currencyProp';
import CountryProp from '../forms/Address/CountryProp';

/** Modal responsible to save market infos, shippingCountry, currency to be used in BRAVON APP */
// Also it renders a message to warn the users that cookies are being saved to enhance performance
function MarketInfosModal({
  t,
  countries,
  currencies,
  marketInfos,
  onChange,
  onClose,
}) {
  const handleChange = field => value => {
    onChange(field, value);
  };
  const handleClose = () => {
    onClose();
  };
  return (
    <GenericModal
      modalId="notLoggedModal"
      title={t('welcome')}
      message={
        <div className="notLoggedInfoModal">
          <p>{t('modal.notLogged.info')}</p>
          <FormInput
            id="localCountry"
            value={marketInfos.localCountry}
            name="localCountry"
            placeholder={t('modal.notLogged.country.placeholder')}
            type="select"
            label={t('modal.notLogged.country')}
            labelClassName="col-3 text-right"
            containerClassName="col-7"
            groupProps={{ className: 'row' }}
            onChange={handleChange('localCountry')}
            inputProps={{
              searchable: true,
              items: countries.map(c => ({
                id: c.code,
                text: `${c.flagEmoji} ${c.name}`,
              })),
              dropdownParent: '#notLoggedModal',
            }}
          />
          <FormInput
            id="localCurrency"
            value={marketInfos.localCurrency}
            name="localCurrency"
            placeholder={t('modal.notLogged.currency.placeholder')}
            type="select"
            label={t('modal.notLogged.currency')}
            labelClassName="col-3 text-right"
            containerClassName="col-7"
            groupProps={{ className: 'row' }}
            onChange={handleChange('localCurrency')}
            inputProps={{
              searchable: true,
              items: currencies.map(c => ({
                id: c.code,
                text: c.name,
              })),
              dropdownParent: '#notLoggedModal',
            }}
          />
        </div>
      }
      onClose={handleClose}
      saveMessage={t('continue')}
    />
  );
}

MarketInfosModal.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  marketInfos: PropTypes.shape({
    localCurrency: PropTypes.string,
    localCountry: PropTypes.string,
    localLanguage: PropTypes.string,
  }),
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType)),
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType)),
};
MarketInfosModal.defaultProps = {
  marketInfos: PropTypes.shape({
    localCurrency: '',
    localCountry: '',
    localLanguage: '',
  }),
  currencies: [],
  countries: [],
};

export default translate(MarketInfosModal);
